<template>
    <div class="project">
        <Title :title="project.title"/>

        <ul class="zt-list">
            <li
            v-for="(item, index) in list"
            :key="index">
                <el-link
                :href="item.body"
                target="_blank"
                :underline="false">
                    <img
                    :src="item.image"
                    lazy>
                </el-link>
            </li>
        </ul>
    </div>
</template>

<script>
import { getProject } from '../../api'

export default {
    name: 'Project',
    props: ['project'],
    data() {
        return {
            list: []
        }
    },
    mounted() {
        // 如果是静态的
        if(this.project.list) {
            this.list = this.project.list
            return
        }
        
        getProject(this.project.params)
        .then(res => {
            // console.log(res)
            let list = []
            res.list.forEach(item => {
                if(!document.title.includes(item.title)) {
                    list.push(item)
                }
            })
            this.list = list.slice(0, 4)
        })
    }
}
</script>

<style scoped>
.project .zt-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.project .zt-list li {
    flex: 0 0 49%;
    opacity: .85;
    margin-bottom: 10px;
    transition: all .3s ease-in-out;
}

.project .zt-list li:hover {
    opacity: 1;
}

.project .zt-list img {
    width: 100%;
    border-radius: 4px;
}
</style>